module.exports = __webpack_public_path__ + "static/media/Caja2.e0900d3d.png";